import styled from 'styled-components';

import { Popper } from '@material-ui/core';

export const Modal = styled(Popper)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;

  & > span {
    font-size: 25px;
    color: #fff;
  }
`;

export const Container = styled.div``;
